import { Observable } from "rxjs";

import { post } from "@utils/axios";
import sessionService from "./session.service";

class PatientProfileService {

  fetchPatientsList({ patient_name, uId}: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/patientProfileReport/fetchPatientsList`, {
        patient_name,
        uId
    });
  }

  fetchPatientProfileData({ patient_id}: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/patientProfileReport/fetchPatientProfileData`, {
      patient_id
    });
  }
  
}

export default new PatientProfileService();
